import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  color: #2e2e2e;
  border: 0.75px solid #6a6a6a;
  border-radius: 6px;

  ${({ theme }) => css`
    ${theme.prompts.item.styles}

    @media (${theme.mediaMobile}) {
      font-size: 14px;
      ${theme.prompts.item.mobile}
    }

    @media not (${theme.mediaMobile}) {
      font-size: 12px;
      ${theme.prompts.item.desktop}
    }
  `}

  &:disabled {
    opacity: 0.6;
  }

  span {
    flex-shrink: 0;
  }
`;

export const Icon = styled.img`
  margin-right: 6px;
`;
